import { useAppSelector } from '@/store';
import { selectConstant } from '@/store/slices/constantsSlice';

/**
 * Returns the live value of an admin-tunable constant. Returns the registry
 * default while the initial `fetchConstants` is in flight (or on failure) so
 * callers never have to special-case loading.
 */
export function useConstant(key: string): number {
  return useAppSelector((s) => selectConstant(s, key));
}
